module.exports = __webpack_public_path__ + "img/portfolio-bg.38433560.png";